// extracted by mini-css-extract-plugin
export default {"NewRulesetButton":"OverviewPage-module__NewRulesetButton__h4TKIw1"};